export default __webpack_public_path__ + "media/zurb/img/icons/services/product-1baf5c8830368443b5ad1115ae16f8f7.svg";